import { FILESTORE_API_URL } from '../../lib/environment.js';
// HACK: Should use lodash's version but this is a quick fix
import { escapeRegExp } from '@bay-ui/BayPolotnoEditor/utils';

export const apiUrlToFindEntriesInFolder = ({
	rootPath,
	folderPath,
	limit = null,
	offset = 0,
	search,
	sort = '_type:desc',
	entryType,
	queryString,
	showHidden,
}) => {
	// FILESTORE_MIGRATION: rootPath is now the partition name
	const partition = rootPath; // e.g., 'brand-assets', 'brand-library', 'design-assets'

	// Build glob without partition prefix - avoid creating paths like 'brand-library/*/'
	// folderPath should be clean (e.g., 'some/folder' or '' or null)
	const searchPattern = search && search !== '' ? '**' : '*';
	const pathComponents = [folderPath, searchPattern].filter(Boolean);
	const glob =
		pathComponents.length > 0 ? pathComponents.join('/') : searchPattern;

	const rgx =
		search && search !== ''
			? search?.split(/\s+/).map(escapeRegExp).join('.*')
			: null;

	let q = JSON.stringify(rgx ? { name: { $regex: rgx, $options: 'i' } } : {}); // {..., isHidden: false, ...}

	let qArray = [];

	if (rgx && showHidden) {
		qArray.push({ name: { $regex: rgx, $options: 'i' } });
	}

	if (queryString) {
		qArray.push(queryString);
	}

	if (showHidden !== '' && showHidden !== undefined && showHidden !== null) {
		qArray.push({ isHidden: showHidden });
	}

	if (qArray.length > 0) {
		q = JSON.stringify({ $and: qArray });
	}

	// FILESTORE_MIGRATION: Use new $Type notation instead of .type
	const entryTypeValue = entryType
		? `$${entryType.charAt(0).toUpperCase() + entryType.slice(1)}`
		: '';

	// FILESTORE_MIGRATION: Use partition-based route
	const url = new URL(
		`${FILESTORE_API_URL}/partitions/${partition}/entries${entryTypeValue}`,
	);

	url.search = new URLSearchParams({ glob, limit, offset, q, sort }).toString();

	return url.href;
};
